import React, { useEffect, useMemo, useState } from 'react';
import './CreateCustomPOIPackage.scss';
import LsBreadcrumb from 'atoms/LsBreadcrumb/LsBreadcrumb';
import PageHeader from 'atoms/PageHeader/PageHeader';
import SLButton from 'atoms/SLButton/SLButton';
import { Col, Input, Row } from 'reactstrap';
import {
  BRAND,
  CATEGORY,
  EMPTY_STRING,
  INTERESTS,
  POI_PACKAGE_STATUS,
  SELECT_ALL_CLEAR,
} from 'commons/constants';
import { useDispatch, useSelector } from 'react-redux';
import FilterPopOver from '../Components/FilterComponent';
import {
  getPoiFilterValues,
  resetFilterValueTOFirstLoad,
  resetPoiFilterValues,
} from 'ooh/Planner/redux/actions/getPoiFilterAction';
import {
  getLatLngData,
  resetLatLngData,
} from 'ooh/Planner/redux/actions/getLatLng';
import {
  getPOIPackageById,
  getPOIPoints,
  postPOIPackage,
  putPoiPackageRemovePoi,
  resetGetPOIPoints,
  resetGetPoiPointsById,
  resetPostPOIPackage,
  resetPutPoiPackageRemovePoi,
} from 'ooh/Planner/redux/actions/getPOIPointsData';
import { BREAD_CRUMB } from './constants';
import POITableData from '../Components/POITableData';
import {
  useHistory,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import { toast, ToastContainer } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';

const initialAudienceSubFilter = { brand: false, category: false };
const CreateCustomPOIPackage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { poipackageId } = useParams();
  const [poiPackageName, setPoiPackageName] = useState(EMPTY_STRING);
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedPOI, setSelectedPOI] = useState([]);
  const [poiData, setPoiData] = useState([]);
  const [selectedPOIIds, setSelectedPOIIds] = useState([]);
  const [existingPOIData, setExistingPOIData] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedPOIIdsForInclude, setSelectedPOIIdsForInclude] = useState([]);
  const [selectedPOIIdsForIncludeForEdit, setSelectedPOIIdsForIncludeForEdit] =
    useState([]);
  const [audienceSubFilter, setAudienceSubFilter] = useState(
    initialAudienceSubFilter
  );
  const [checkedFilters, setCheckedFilters] = useState({ interests: {} });

  const { poiPointsData, filteredValues, poiPackages, latLngData } =
    useSelector((state) => state.ooh);

  const selectedAccount = useSelector(
    (state) => state.authorization.selectedAccount
  );

  const selectAllPOI = (e) => {
    setSelectAll(e.target.checked);
    if (e.target.checked) {
      setSelectedPOIIds((prev) => [
        ...prev,
        ...poiData.map((item) => item.placeDBId),
      ]);
      setSelectedPOI((prev) => [...prev, ...poiData]);
    } else {
      setSelectedPOIIds([]);
      setSelectedPOI([]);
    }
  };

  const resetState = () => {
    setPoiPackageName(EMPTY_STRING);
    setSelectedPOIIds([]);
    setSelectedPOI([]);
    setSelectedPOIIdsForInclude([]);
    setExistingPOIData([]);
    setIsFirstLoad(true);
    setIsLoading(true);
    setOpenFilter(false);
    setSelectAll(false);
    setSelectedPOIIdsForIncludeForEdit([]);
    setAudienceSubFilter(initialAudienceSubFilter);
    setCheckedFilters({ interests: {} });
  };

  const resetFilterValueToFirstLoad = () => {
    dispatch(resetFilterValueTOFirstLoad());
  };

  const resetFilterValue = () => {
    setCheckedFilters({ interests: {} });
  };

  const selectAllFilter = () => {
    setCheckedFilters((prev) => {
      const obj = { ...prev };
      obj[INTERESTS] = filteredValues.filteredValues.id.reduce((acc, item) => {
        item.filterAudienceDataList.forEach((childItem) => {
          acc[childItem.filterId] = childItem;
        });
        return acc;
      }, {});
      return obj;
    });
  };

  const resetAllRedux = () => {
    dispatch(resetPostPOIPackage());
    dispatch(resetPutPoiPackageRemovePoi());
    dispatch(resetPoiFilterValues());
    dispatch(resetLatLngData());
    dispatch(resetGetPoiPointsById());
    dispatch(resetGetPOIPoints());
  };

  useEffect(() => {
    dispatch(resetGetPOIPoints());
    return () => {
      setIsLoading(true);
      resetAllRedux();
      resetState();
    };
  }, []);

  //   Add APi call to fetch the existing POI data by ID
  useEffect(() => {
    if (poipackageId) {
      dispatch(getPOIPackageById({ id: poipackageId }));
    }
  }, [poipackageId]);

  useEffect(() => {
    if (filteredValues.firstLoadFilterValues && isFirstLoad) {
      setIsFirstLoad(false);
      const temp_Data =
        filteredValues?.firstLoadFilterValues?.id?.[1]
          ?.filterAudienceDataList?.[0] ?? undefined;

      if (temp_Data) {
        const tempCheckedFilters = {
          interests: {
            [temp_Data.filterId]: temp_Data,
          },
        };

        //   filteredValues.firstLoadFilterValues.id?.reduce((acc, item) => {
        //     acc[item.filterAudienceDataList[0].filterId] =
        //       item.filterAudienceDataList[0];
        //     return acc;
        //   }, {}) ?? {},
        // setCheckedFilters(tempCheckedFilters);
        // _handleOnInclude(tempCheckedFilters);
      }
    }
  }, [filteredValues.firstLoadFilterValues]);

  useEffect(() => {
    if (
      poiPointsData.postPoiPackageData.changingStatus ===
      POI_PACKAGE_STATUS.SUCCESS
    ) {
      toast.success('POI Package created successfully');

      resetState();
      dispatch(resetPostPOIPackage());
      history.push('/ooh/poi/packages');
    }
  }, [poiPointsData.postPoiPackageData.changingStatus]);

  useEffect(() => {
    if (
      poiPointsData.getPoiPackageByIdData.changingStatus ===
      POI_PACKAGE_STATUS.SUCCESS
    ) {
      setPoiPackageName(
        poiPointsData.getPoiPackageByIdData.data.packageName ?? EMPTY_STRING
      );
      setSelectedPOIIds([
        ...poiPointsData.getPoiPackageByIdData.data.poiList.map(
          (item) => item.placeDBId
        ),
        ...selectedPOIIdsForIncludeForEdit,
      ]);
      setSelectedPOIIdsForInclude((prev) => {
        const tempSelectedData = prev.filter((item) => !item?.isExisiting);
        return [
          ...(poiPointsData.getPoiPackageByIdData.data?.poiList ?? []),
          ...tempSelectedData,
        ];
      });
      setExistingPOIData(
        poiPointsData.getPoiPackageByIdData.data?.poiList ?? []
      );
    }
  }, [poiPointsData.getPoiPackageByIdData.changingStatus]);

  const handleOnCheckBoxClick = (_, data, name) => {
    setCheckedFilters((prev) => {
      const obj = { ...prev };
      if (obj[name] && data.filterId in obj[name]) {
        delete obj[name][data.filterId];
      } else {
        obj[name] = {
          ...(obj[name] ?? {}),
          [data.filterId]: data,
        };
      }
      return obj;
    });
  };

  const postPayloadCreator = (selectedPOIIdsForInclude) => {
    return selectedPOIIdsForInclude.map((item) => ({
      poiId: item.placeDBId,
      poiName: item.placeName,
      latitude: item.latitude,
      longitude: item.longitude,
      lonlat: {
        lat: item.latitude,
        lon: item.longitude,
      },
    }));
  };

  const _handlePostPOIPackage = () => {
    dispatch(
      postPOIPackage({
        packageName: poiPackageName,
        poiList: postPayloadCreator(selectedPOIIdsForInclude),
      })
    );
  };

  const _handelPoiPackageName = (e) => {
    setPoiPackageName(e.target.value);
  };

  const _handleOpenFilter = (flag = false) => {
    setOpenFilter(flag);
  };

  const _handleRemove = (name, title) => {
    setCheckedFilters((prev) => {
      const obj = Object.values(prev[name]);
      const result = obj
        .filter((item) => {
          return item.type !== title;
        })
        .reduce((acc, item) => {
          acc[item.filterId] = item;
          return acc;
        }, {});
      return { [name]: result };
    });
  };
  const _handleSectionSelectAll = (name, title, values) => {
    setCheckedFilters((prev) => {
      const obj = { ...prev };
      values.forEach((item) => {
        obj[name][item.filterId] = item;
      });
      return obj;
    });
  };

  const _handleOnAudienceSubFilter = (filterName, children, clickdOrigin) => {
    const openState = audienceSubFilter;
    if (SELECT_ALL_CLEAR.includes(clickdOrigin)) {
      setAudienceSubFilter((prev) => ({
        ...prev,
        [filterName]: true,
      }));
    } else {
      if (openState && Object.hasOwn(openState, filterName)) {
        setAudienceSubFilter({
          ...initialAudienceSubFilter,
        });
      } else {
        setAudienceSubFilter({
          ...initialAudienceSubFilter,
          [filterName]: true,
        });
      }
    }
  };

  const _handleOnFilterChange = (event, name) => {
    let searchFlag = true;
    const { value } = event.target;
    const searchString = value?.trim().toLowerCase();
    let result = [];
    filteredValues.filteredValues = JSON.parse(
      JSON.stringify(filteredValues.firstLoadFilterValues)
    );
    if (searchString.length === 0) {
      result = [...filteredValues.filteredValues.id];
    } else {
      filteredValues?.filteredValues?.id?.forEach((parentFilter) => {
        if (
          parentFilter.filterName.trim()?.toLowerCase()?.includes(searchString)
        ) {
          result.push(parentFilter);
        } else {
          const childFilters = parentFilter?.filterAudienceDataList.filter(
            (childFilter) =>
              childFilter.filterName.trim().toLowerCase().includes(searchString)
          );
          if (childFilters?.length) {
            parentFilter.filterAudienceDataList = [...childFilters];
            result.push(parentFilter);
          }
        }
      });
    }
    dispatch(getPoiFilterValues({ searchFlag, result }));
  };

  const _fetchBrandAndCategory = () => {
    dispatch(
      getPoiFilterValues({
        countryId: selectedAccount?.countryId,
        customerId: selectedAccount?.customerId,
        name: INTERESTS,
        searchFlag: false,
      })
    );
  };
  useEffect(() => {
    if (selectedAccount?.countryId) {
      _fetchBrandAndCategory();
    }
  }, [selectedAccount?.countryId]);

  const _handleOnInclude = (_checkedFilters) => {
    const latLongPayload = {
      countryId: selectedAccount?.countryId,
      customerId: selectedAccount?.customerId,
      includedValue: { interests: Object.values(_checkedFilters[INTERESTS]) },
      distance: 1000,
      expressions: [],
      excludeAudienceForScreenFilter: false,
    };
    setOpenFilter(false);
    resetFilterValueToFirstLoad();
    dispatch(getLatLngData(latLongPayload));
  };

  const handleGetPoiPoints = () => {
    const includedValue = {
      interests: Object.values(checkedFilters[INTERESTS]),
    };
    if (Object.hasOwn(includedValue ?? {}, INTERESTS)) {
      const payload = {
        placeIds: latLngData.latLngData.id
          ?.filter((place, index) => index < 1000)
          ?.map((place) => place.placeId),
        brandIds: includedValue?.interests
          .filter((poiFilter) => poiFilter.type === BRAND)
          ?.map((poiFilter) => poiFilter.filterId),
        categoryIds: includedValue?.interests
          .filter((poiFilter) => poiFilter.type === CATEGORY)
          ?.map((poiFilter) => poiFilter.filterId),
        distance: 1,
      };
      if (payload.brandIds.length > 0 || payload.categoryIds.length > 0) {
        dispatch(getPOIPoints({ ...payload }));
      }
    }
  };

  useEffect(() => {
    if (latLngData.changingStatus === POI_PACKAGE_STATUS.SUCCESS) {
      handleGetPoiPoints();
    }
  }, [latLngData]);

  useEffect(() => {
    if (latLngData.changingStatus === POI_PACKAGE_STATUS.SUCCESS) {
      setOpenFilter(false);
      setIsLoading(false);
    }
  }, [latLngData.changingStatus]);

  const isFilterDisabled = useMemo(
    () =>
      !checkedFilters[INTERESTS] ||
      Object.keys(checkedFilters[INTERESTS]).length === 0 ||
      latLngData.changingStatus === POI_PACKAGE_STATUS.ONGOING,
    [checkedFilters, latLngData.changingStatus]
  );

  const handleOnSelectPOI = (e, data, isSelectedScreens = false) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedPOIIds((prev) => [...prev, data.placeDBId]);
      setSelectedPOI((prev) => [...prev, data]);
    } else {
      const tempPoiIds = selectedPOIIds.filter(
        (item) => item !== data.placeDBId
      );
      setSelectedPOIIds(tempPoiIds);
      if (isSelectedScreens) {
        const tempPoiData = poiPointsData?.poiPoints.filter(
          (item) => !tempPoiIds.includes(item.placeDBId)
        );
        setPoiData(tempPoiData);
      }
      setSelectedPOIIdsForInclude((prev) =>
        prev.filter((item) => item.placeDBId !== data.placeDBId)
      );
      setSelectedPOI((prev) =>
        prev.filter((item) => item.placeDBId !== data.placeDBId)
      );
    }
    // setSelectedPOI(placeIds);
  };

  useEffect(() => {
    if (
      poiPointsData.putPoiPackageRemovePoiData.changingStatus ===
      POI_PACKAGE_STATUS.SUCCESS
    ) {
      toast.success('POI Updated successfully');
      dispatch(getPOIPackageById({ id: poipackageId }));
      handleGetPoiPoints();
      setSelectedPOIIdsForInclude([]);
      setSelectedPOIIdsForIncludeForEdit([]);
      dispatch(resetPutPoiPackageRemovePoi());
    }
  }, [poiPointsData.putPoiPackageRemovePoiData.changingStatus]);

  useEffect(() => {
    const tempData = poipackageId
      ? poiPointsData?.poiPoints
          ?.filter(
            (item) =>
              !poiPointsData.getPoiPackageByIdData.data?.existingIds.includes(
                item.placeDBId
              )
          )
          .filter(
            (item) => !selectedPOIIdsForIncludeForEdit.includes(item.placeDBId)
          ) ?? []
      : selectedPOIIdsForIncludeForEdit.length > 0
        ? poiPointsData?.poiPoints.filter(
            (item) => !selectedPOIIdsForIncludeForEdit.includes(item.placeDBId)
          )
        : poiPointsData?.poiPoints;
    setPoiData(tempData ?? []);
  }, [poiPointsData]);

  const _handleOnIncludeSelectedPOIs = () => {
    //includ the data coming from the fetch of Poi in Edit POI Package
    setSelectedPOIIdsForInclude([...existingPOIData, ...selectedPOI]);
    setSelectedPOIIdsForIncludeForEdit((prev) => [...prev, ...selectedPOIIds]);
    setPoiData(
      poiPointsData?.poiPoints.filter(
        (item) => !selectedPOIIds.includes(item.placeDBId)
      )
    );
    setSelectAll(false);
  };
  const disableAddSelectedPOIs = useMemo(() => {
    return (
      selectedPOI.length ===
      selectedPOIIdsForInclude.length - existingPOIData.length
    );
  }, [selectedPOIIdsForInclude, selectedPOI, existingPOIData]);

  const disableSaveButton = useMemo(
    () =>
      selectedPOIIdsForInclude.filter((item) => !item?.isExisiting).length ===
        0 || poiPackageName.length === 0,
    [selectedPOIIdsForInclude, poiPackageName]
  );

  const putObjectCreator = (item) => {
    const { latitude, longitude, ...rest } = item;
    return {
      latitude,
      longitude,
      poiName: rest.placeName,
      poiId: rest.placeDBId,
    };
  };

  const handleOnRemovePOI = (item) => {
    const payload = {
      poiPackageId: poipackageId,
      removePoiList: [putObjectCreator(item)],
    };
    dispatch(putPoiPackageRemovePoi(payload));
  };

  const handlePutPoiPackage = () => {
    const payload = {
      poiPackageId: poipackageId,
      addPoiList: postPayloadCreator(
        selectedPOIIdsForInclude.filter((item) => !item.isExisiting)
      ),
    };
    dispatch(putPoiPackageRemovePoi(payload));
  };

  const handleBack = () => {
    history.push('/ooh/poi/packages');
  };

  return (
    <div className="content d-flex flex-column poi_package_container">
      <LsBreadcrumb breadcrumbList={BREAD_CRUMB} />
      <PageHeader
        title={`${poipackageId ? 'Edit' : 'Create'} Custom POI Package`}
        className="mb-3"
      />
      <section className="bg-white p-3 pb-2 rounded flex-grow-1 d-flex flex-column">
        <Row className="justify-content-between mb-2 border-bottom pb-3">
          <Col xs={4}>
            <Input
              placeholder="Enter POI Package Name"
              className="w-100"
              onChange={_handelPoiPackageName}
              value={poiPackageName}
              disabled={poipackageId}
            />
          </Col>
          <Col xs={2}>
            {/* <SLButton
              title="Filter"
              id="Popover-Filter"
              outline
              size="sm"
              style={{ width: '100%' }}
              onClick={() => _handleOpenFilter(true)}
            /> */}
          </Col>
        </Row>

        <div>
          <Row className={'poi_package_table'}>
            <Col xs={4}></Col>
            {/* <Col xs={4}>
              <SearchInput
                placeholder="Start typing to search POI..."
                value={searchText}
                onChange={_searchText}
                clearValue={clearSearchText}
                id="searchInput"
              />
            </Col>
            <Col xs={6}>
              <Row>
                <Col xs={6}>
                  <MultiSelect
                    options={brandAndCategory.BRAND}
                    placeholder="Select brands"
                    handleChange={(value) => hangelFilterChange('BRAND', value)}
                    selectedOption={selectedFilters.BRAND}
                    isMulti={true}
                    closeMenuOnSelect={false}
                  />
                </Col>
                <Col xs={6}>
                  <MultiSelect
                    options={brandAndCategory.CATEGORY}
                    placeholder="Select Categories"
                    handleChange={(value) => hangelFilterChange('CATEGORY', value)}
                    selectedOption={selectedFilters.CATEGORY}
                    isMulti={true}
                    closeMenuOnSelect={false}
                  />
                </Col>
              </Row>
            </Col> */}
          </Row>
        </div>

        {openFilter && (
          <FilterPopOver
            filteredValues={filteredValues}
            poiPackages={poiPackages}
            checkedFilters={{
              interests: Object.values(checkedFilters['interests']),
            }}
            audienceSubFilter={audienceSubFilter}
            _handleRemove={_handleRemove}
            _handleOnCheckBoxClick={handleOnCheckBoxClick}
            _handleSectionSelectAll={_handleSectionSelectAll}
            _handleOnAudienceSubFilter={_handleOnAudienceSubFilter}
            _handleOnCloseFilter={() => _handleOpenFilter(false)}
            _handleOnFilterChange={_handleOnFilterChange}
            _handleOnInclude={() => _handleOnInclude(checkedFilters)}
            isFilterDisabled={isFilterDisabled}
            changingStatus={latLngData.changingStatus}
            resetAllFilter={resetFilterValue}
            selectAllFilter={selectAllFilter}
          />
        )}
        <section className="bg-white pt-1 rounded flex-grow-1 d-flex flex-column">
          <POITableData
            label={'Available Locations'}
            headerConfig={[
              {
                id: 'select',
                label: (
                  <input
                    type="checkbox"
                    className="cstm_tab_checkbox"
                    disabled={poiData.length === 0}
                    checked={selectAll}
                    onChange={selectAllPOI}
                  />
                ),
              },
              { id: 'placeName', label: 'POI Name' },
              //   { id: 'address', label: 'Address' },
              {
                id: 'include',
                label: (
                  <button
                    className={`include_btn filter_btn`}
                    id="Popover-Filter"
                    onClick={() => _handleOpenFilter(true)}
                  >
                    Filters
                  </button>
                ),
              },
            ]}
            data={poiData}
            changingStatus={poiPointsData.changingStatus}
            changingStatus2={
              latLngData.changingStatus === POI_PACKAGE_STATUS.ONGOING
            }
            noDataMessage={{
              title: 'No POI Points Found',
              message: 'Please try again with different filters',
            }}
            initialMessage={{
              title: 'Please apply filters to get Locations',
              message: 'Please apply filters to get Locations',
            }}
            // sortable={['placeName', 'address']}
            // onSort={() => {}}
            rowComponent={POIPackageRow({
              selectedPOIIds,
              handleOnSelectPOI,
              handleOnRemovePOI,
              isSelectedScreens: false,
            })}
          />
          <div className="d-flex justify-content-end pt-3">
            {' '}
            <SLButton
              title="Add Selected Locations"
              outline
              size="sm"
              onClick={() => _handleOnIncludeSelectedPOIs()}
              disabled={disableAddSelectedPOIs}
            />
          </div>
          <hr />
          <POITableData
            label={'Selected Locations'}
            headerConfig={[
              { id: 'select', label: '' },
              { id: 'placeName', label: 'POI Name' },
              //   { id: 'address', label: 'Address' },
              {
                id: 'include',
                label: '',
              },
            ]}
            data={selectedPOIIdsForInclude}
            changingStatus={
              poipackageId
                ? poiPointsData.getPoiPackageByIdData.changingStatus
                : poiPointsData.changingStatus
            }
            noDataMessage={{
              title: 'No Location Selected',
              message: 'Please select Location and Include from above table',
            }}
            initialMessage={{
              title: 'Please select Location and Include from above table',
              message: 'Please select Location and Include from above table',
            }}
            rowComponent={POIPackageRow({
              selectedPOIIds: selectedPOIIdsForIncludeForEdit,
              handleOnSelectPOI,
              handleOnRemovePOI,
              isSelectedScreens: true,
            })}
          />
        </section>

        <div className="  border-top pt-3">
          <Row className="w-full" style={{ width: '25%', float: 'right' }}>
            <Col xs={6}>
              <SLButton
                title="Back"
                outline
                size="md"
                onClick={handleBack}
                style={{ width: '100%' }}
              />
            </Col>
            <Col xs={6}>
              <SLButton
                title={poipackageId ? 'Save' : 'Create'}
                size="md"
                disabled={
                  disableSaveButton ||
                  poiPointsData.postPoiPackageData.changingStatus ===
                    POI_PACKAGE_STATUS.ONGOING ||
                  poiPointsData.putPoiPackageRemovePoiData.changingStatus ===
                    POI_PACKAGE_STATUS.ONGOING
                }
                style={{ width: '100%' }}
                onClick={
                  poipackageId ? handlePutPoiPackage : _handlePostPOIPackage
                }
              />
            </Col>
          </Row>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default CreateCustomPOIPackage;

export const POIPackageRow = ({
  selectedPOIIds,
  handleOnSelectPOI,
  handleOnRemovePOI,
  isSelectedScreens = false,
}) => {
  return ({ index, style, data: { items } }) => {
    return (
      <section
        className={`row-item row-item-${index % 2} poi_package_list`}
        style={style}
      >
        {items[index]?.isExisiting ? (
          <div className="cellItem">
            <FaTimes
              size={12}
              className="cursor-pointer "
              title="Remove POI"
              onClick={() => handleOnRemovePOI?.(items[index])}
            />
          </div>
        ) : (
          <div className="cellItem">
            <input
              type="checkbox"
              className="cstm_tab_checkbox"
              checked={
                selectedPOIIds?.includes(items[index].placeDBId) ?? false
              }
              onChange={(e) =>
                handleOnSelectPOI?.(e, items[index], isSelectedScreens)
              }
            />
          </div>
        )}
        <div className="cellItem">{items[index].placeName}</div>
      </section>
    );
  };
};
